import React, { createContext } from 'react';

const SmoothRContext = createContext();
export { SmoothRContext };
